import { ButtonVariant } from "../../Models/ButtonModel";

export default function getButtonVariant(buttonVariant?: ButtonVariant): "text" | "contained" | "outlined" {
  if (buttonVariant) {
    switch (buttonVariant) {
      case ButtonVariant.ButtonContained:
        return "contained";
      case ButtonVariant.ButtonOutlined:
        return "outlined";
      case ButtonVariant.Button:
        return "text";
    }
  }
  return "text"; // default variant
}
